import { Link, useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { PaymentApi } from "../../api/services";
import { PageHeader, StatusBadge } from "../../components/common";
import { peso } from "../../lib/format";

// Return page after PayMongo hosted checkout. Status always comes from server-side verification, never the URL.
export default function PayReturn() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const { data: p } = useQuery({
    queryKey: ["payment", id], queryFn: () => PaymentApi.get(id),
    refetchInterval: (q) => (q.state.data?.status === "pending" ? 3000 : false),
  });
  const back = p?.purpose === "membership" ? "/patient/membership" : p ? `/patient/bookings/${p.ref_id}` : "/";
  return (
    <div className="space-y-5">
      <PageHeader title="Payment status" />
      <div className="fp-card space-y-3" data-testid="payment-return-card">
        {!p ? <Loader2 className="animate-spin" /> : (
          <>
            <div className="flex items-center justify-between"><p className="font-semibold">{p.description}</p><StatusBadge status={p.status} testId="payment-return-status" /></div>
            <p className="text-2xl font-bold text-[#036248]">{peso(p.amount)}</p>
            <p className="text-sm text-slate-600">
              {p.status === "paid" ? "Payment confirmed by the server." : p.status === "pending"
                ? (params.get("cancelled") ? "Checkout was cancelled. No payment confirmed." : "Waiting for payment confirmation from PayMongo…")
                : "Payment was not completed."}
            </p>
          </>
        )}
      </div>
      <Link to={back} className="fp-btn-secondary w-full">Continue</Link>
    </div>
  );
}
